module.exports = "tr {\r\n\tcursor: pointer; \r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/reports/report-list/report-list.component.css
// module id = ./src/app/reports/report-list/report-list.component.css
// module chunks = main